import React, { createContext, useContext, useState } from "react";
import PropTypes from "prop-types";
import useLogger from "../util/Logger";
import { useAuth } from "./AuthHook";

const CategoriesContext = createContext();

export default function CategoriesProvider({ children }) {
  const logger = useLogger();
  const auth = useAuth();
  const [currentCategories, setCategories] = useState([]);
  const [currentCategoriesType, setCategoriesType] = useState([]);

  const updateCategories = async (forType) => {
    try {
      logger.debug(
        "CategoriesProvider.updateCategories",
        `GET field/workOrder/category?workOrderType=${forType}`
      );

      const data = await auth.get(
        encodeURI(`field/workOrder/category?workOrderType=${forType}`)
      );

      logger.debug("CategoriesProvider.updateCategories", `Retrieved data`);

      return data.sort((a, b) => {
        if (a.name > b.name) return 1;
        if (a.name < b.name) return -1;
        return 0;
      });
    } catch (error) {
      logger.debug(
        "CategoriesProvider.updateCategories",
        `Failed to retrieve data: ${JSON.stringify(error)}`
      );
      return [];
    }
  };

  const getCategories = async (forType) => {
    let categories = currentCategories;
    if (categories.length === 0 || forType !== currentCategoriesType) {
      categories = await updateCategories(forType);
      setCategoriesType(forType);
      setCategories(categories);
    }
    return categories;
  };

  const getCurrentCategories = () => currentCategories;

  return (
    <CategoriesContext.Provider
      value={{
        getCategories,
        getCurrentCategories,
      }}
    >
      {children}
    </CategoriesContext.Provider>
  );
}

CategoriesProvider.propTypes = {
  children: PropTypes.node.isRequired,
};

export const useCategories = () => useContext(CategoriesContext);
